/** Marketing S23 — scoped broadcast campaigns (Circle migration target). */
export const MARKETING_CAMPAIGN_AUDIENCE_SCOPE_CIRCLE_PREFIX = 'circle:' as const;

export const MARKETING_CIRCLE_DISCUSSION_CTA_LABEL = 'Discuss in Circle';

export const MARKETING_READER_COMMUNITY_COMPOSE_COPY =
  'Optional reader Circle links newsletter archive to a community thread (L-A14 Lite). Full subscriber chat is backlog.';

export function buildCircleAudienceScope(communityId: string): string {
  const id = communityId.trim();
  if (!id) throw new Error('communityId is required');
  return `${MARKETING_CAMPAIGN_AUDIENCE_SCOPE_CIRCLE_PREFIX}${id}`;
}

export function parseCircleAudienceScope(audienceScope: string): string | null {
  const scope = audienceScope.trim();
  if (!scope.startsWith(MARKETING_CAMPAIGN_AUDIENCE_SCOPE_CIRCLE_PREFIX)) return null;
  const communityId = scope.slice(MARKETING_CAMPAIGN_AUDIENCE_SCOPE_CIRCLE_PREFIX.length).trim();
  return communityId || null;
}

export function isCircleAudienceScope(audienceScope: string): boolean {
  return parseCircleAudienceScope(audienceScope) != null;
}
